import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListarActualizacionesFirmComponent } from './listar-actualizaciones-firm/listar-actualizaciones-fim.component';

const routes: Routes = [
  { path: '', component: ListarActualizacionesFirmComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ActualizacionesFirmRoutingModule {}
